import {
  fetchPromptTemplatesRequest,
  fetchSinglePromptTemplateRequest,
  upsertPromptTemplateRequest,
} from 'actions/promptTemplates';
import { LLMPromptTemplate, Selector } from 'types';

export const getPromptTemplate: Selector<LLMPromptTemplate | null> = (state) =>
  state.promptTemplates.activeTemplate;

export const getPromptTemplates: Selector<LLMPromptTemplate[]> = (state) =>
  state.promptTemplates.templates;
export const getPromptTemplatesTotalCount: Selector<number> = (state) =>
  state.promptTemplates.promptTemplatesCount;
export const getPromptTemplatesLoading: Selector<boolean> = (state) =>
  state.promptTemplates.loading.includes(fetchPromptTemplatesRequest.toString());

export const getSinglePromptTemplateLoading: Selector<boolean> = (state) =>
  state.promptTemplates.loading.includes(fetchSinglePromptTemplateRequest.toString());

export const getUpsertPromptTemplateLoading: Selector<boolean> = (state) =>
  state.promptTemplates.loading.includes(upsertPromptTemplateRequest.toString());
